export const wide = 'wide';
export const narrow = 'narrow';
export const laneSwitcher = 'lane-switcher';
